Object.defineProperty(exports, '__esModule', {
  value: true
});
var findById = function findById(arr, id, defaultResponse) {
  if (defaultResponse === void 0) {
    defaultResponse = null;
  }
  var found = arr.find(function (obj) {
    return obj.id === id;
  });
  return found || defaultResponse;
};
exports.findById = findById;